<template>
    <div class="page exam-page py-2 py-md-6" :class="{'white': phoneAndTablet, 'practice-exam': exam && exam.origin === 'student_practice'}">
        <v-container v-if="sessionToken">
            <v-card :flat="phoneAndTablet" class="question-card px-md-5 py-md-4 mt-2 mb-8 mb-lg-2 mx-auto p-relative" :class="{'bordered': !phoneAndTablet}" style="border-radius: 8px!important;" oncontextmenu="return false;">
                <v-overlay v-if="submitting" absolute color="white" opacity="0.75">
                    <!-- <v-progress-circular indeterminate transition="fade-transition" color="primary lighten-1" size="50" width="3" style="z-index: 9999;"></v-progress-circular> -->
                </v-overlay>
                <template v-if="showResult && result && !showDetailedResult">
                    <div class="medium-text px-3 pt-1">
                        <div class="d-flex justify-space-between">
                            <div>
                                <v-icon size="20" color="strong-text" class="me-3">mdi-clipboard-text-outline</v-icon>
                                <b class="strong-text--text">{{exam.name}}</b>
                            </div>
                            <div>
                                <v-btn icon @click="showSubmitted = true; showResult = false;">
                                    <v-icon>mdi-arrow-left</v-icon>
                                </v-btn>
                            </div>
                        </div>
                        <v-divider class="mt-3"></v-divider>
                    </div>
                    <v-card-title>نتيجة الامتحان</v-card-title>
                    <v-card-subtitle>نتيجة التصحيح اﻹلكتروني لإجاباتك على الامتحان</v-card-subtitle>
                    <v-card-text>
                        <v-alert v-if="!result.succeeded" text type="error" icon="mdi-alert-decagram">
                            <b>راسب </b>
                            <span class="strong-text--text ms-4">
                                <span v-if="pcOnly">للأسف لم تتمكن من اجتياز الامتحان..</span>
                                <span v-if="hasMark(result.correction_percentage)"> النسبة المئوية <b>{{result.correction_percentage}}%</b></span>
                            </span>
                        </v-alert>
                        <v-alert v-else text type="success" icon="mdi-check-decagram">
                            <b class="success--text text--darken-1">ناجح!</b>
                            <span class="strong-text--text ms-2 ms-lg-4">
                                <span v-if="pcOnly">تهانينا تم اجتياز الامتحان بنجاح </span>
                                <span v-if="hasMark(result.correction_percentage)">بنسبة <b>{{result.correction_percentage}}%</b></span>
                            </span>
                        </v-alert>
                        <v-list two-line dense class="ma-0 pa-0">
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-icon color="strong-text">mdi-account</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-subtitle>اسم الطالب</v-list-item-subtitle>
                                    <v-list-item-title style="font-weight: 600">{{user.name}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="user.center_id">
                                <v-list-item-icon>
                                    <v-icon color="strong-text">mdi-pound</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-subtitle>كود السنتر</v-list-item-subtitle>
                                    <v-list-item-title style="font-weight: 600">{{user.center_id}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="hasMark(result.correction_mark)">
                                <v-list-item-icon>
                                    <v-icon color="strong-text">mdi-license</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content style="max-width: 50px; text-align: center">
                                    <v-list-item-title class="font-weight-bold">{{result.correction_mark}}</v-list-item-title>
                                    <v-divider></v-divider>
                                    <v-list-item-subtitle class="strong-text--text">{{result.total_mark}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="result.submitted_at">
                                <v-list-item-icon>
                                    <v-icon color="indigo darken-1">mdi-send-check</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-subtitle>تم التسليم في</v-list-item-subtitle>
                                    <v-list-item-title style="font-weight: 600">{{this.dateTimeFormat(result.submitted_at, true)}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="result.correct_answer_attempts">
                                <v-list-item-icon>
                                    <v-icon :color="result.succeeded ? 'success' : 'strong-text'">mdi-checkbox-multiple-marked-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-subtitle>عدد اﻹجابات الصحيحة</v-list-item-subtitle>
                                    <v-list-item-title style="font-weight: 600">{{result.correct_answer_attempts}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="result.wrong_answer_attempts">
                                <v-list-item-icon>
                                    <v-icon color="error">mdi-close-box-multiple-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-subtitle>عدد اﻹجابات الخاطئة</v-list-item-subtitle>
                                    <v-list-item-title style="font-weight: 600">{{result.wrong_answer_attempts}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="result.time_taken">
                                <v-list-item-icon>
                                    <v-icon color="indigo darken-1">mdi-clock-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-subtitle>الوقت المستغرق</v-list-item-subtitle>
                                    <v-list-item-title style="font-weight: 600">{{this.formatSeconds(result.time_taken)}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="exam.show_detailed_result && questions && questions.length" color="primary" outlined @click="active = questions[0].id; showDetailedResult = true" class="px-5 font-weight-bold">
                            <v-icon left>mdi-check-all</v-icon>
                            عرض تصحيح الإجابات
                        </v-btn>
                    </v-card-actions>
                    <div class="px-4 pb-4"><exam-personal-report v-if="result && !isActive" :session-token="sessionToken" @review="openReportQuestion" /></div>
                </template>
                <template v-else-if="showSubmitted && !showDetailedResult">
                    <div class="medium-text px-3 pt-1">
                        <v-icon size="20" color="strong-text" class="me-3">mdi-clipboard-text-outline</v-icon>
                        <b class="strong-text--text">{{exam.name}}</b>
                        <v-divider class="mt-3"></v-divider>
                    </div>
                    <v-card-title>تم تسليم اﻹجابات</v-card-title>
                    <v-card-subtitle>لقد قمت بتسليم اﻹجابات الخاصة بك، مع تمنياتنا لك بالنجاح والتوفيق</v-card-subtitle>
                    <exam-result-wait v-if="!result" :key="sessionToken" :session-token="sessionToken" @ready="getSessionData" />
                    <v-card-actions v-if="result || course_id">
                        <v-btn v-if="result" color="secondary" depressed class="px-4" rounded @click="showResult = true">
                            <v-icon size="20" left>mdi-progress-check</v-icon>
                            عرض النتيجة
                        </v-btn>
                        <v-btn v-if="course_id" color="grey lighten-3" depressed class="px-4" rounded :to="{name: 'course', params: {id: course_id}}">
                            العودة إلى الدورة
                            <v-icon size="20" right>mdi-arrow-left</v-icon>
                        </v-btn>
                    </v-card-actions>
                </template>
                <template v-else-if="session">
                    <div class="d-flex justify-space-between w-100 px-md-5" :class="{'question-chips': pcOnly}">
                        <div>
                            <v-chip color="primary" dark :label="phoneOnly" class="question-chip font-weight-bold lg-shadow">
                                <v-progress-circular v-if="activeQuestionLoading" indeterminate color="white" size="16" width="2" class="me-2" ></v-progress-circular>
                                <v-icon v-else size="18" class="me-2">{{activeQuestion.type === 'essay' ? 'mdi-text-box-outline' : 'mdi-file-question-outline'}}</v-icon>
                                السؤال {{activeQuestionIndex}} / {{questions.length}}
                            </v-chip>
                        </div>
                        <div>
                            <v-chip v-if="isActive && exam.duration && remainingSeconds !== null" color="white" :label="phoneOnly" class="question-chip font-weight-bold bordered soft-shadow" :class="{'orange--text text--darken-2': remainingSeconds < 600 && remainingSeconds >=180, 'red--text': remainingSeconds < 180}">
                                <v-icon size="18" class="me-2">mdi-timer-outline</v-icon>
                                <span class="medium-text">{{timerFormated}}</span>
                            </v-chip>
                        </div>

                    </div>
                    <v-alert v-if="isActive && failedSaveQuestions.length" type="warning" outlined role="alert">
                        تعذر حفظ بعض الإجابات. احتفظ بهذه الصفحة مفتوحة وأعد المحاولة قبل المغادرة.
                        <v-btn text :loading="sendingAnswerOfQuestions.length > 0" @click="retryFailedAnswers">إعادة الحفظ</v-btn>
                    </v-alert>
                    <div class="my-3 mb-lg-0 medium-text strong-text--text d-flex justify-space-between flex-column flex-lg-row">
                        <div>
                            {{exam.name}} 
                            <span v-if="exam.duration" class="muted--text details-text ms-1">({{exam.duration}} دقيقة)</span>
                            <span v-else class="muted--text details-text ms-1">(بلا مؤقّت)</span>
                        </div>

                        <v-btn v-if="showDetailedResult" outlined text color="secondary" @click="showDetailedResult = false" class="mt-2 mt-lg-0">
                            العودة للنتيجة
                            <v-icon right>mdi-arrow-left</v-icon>
                        </v-btn>
                    </div>
                    
                    <transition :name="isActive || showDetailedResult ? 'fade-up' : ''" mode="out-in">
                    <div v-if="active" :key="active">
                        <div class="question-header d-flex justify-space-between my-5">
                            <div v-if="showDetailedResult" class="mb-4">
                                <span v-if="!chosenAnswerItem.answer_attempt_id && !chosenAnswerItem.chosen_answer" class="orange--text text--darken-2" style="font-size: 1.1rem">
                                    <v-icon color="orange darken-2" class="me-1">mdi-alert-decagram-outline</v-icon>
                                    لم يتم الإجابة
                                </span>
                                <span v-if="reviewState(chosenAnswerItem) === 'full' || reviewState(chosenAnswerItem) === 'partial'" :class="{'success--text': !isAnswerItemNotFullMark(chosenAnswerItem)}">
                                    <v-icon :color="!isAnswerItemNotFullMark(chosenAnswerItem) ? 'success' : 'text'">mdi-check-decagram-outline</v-icon>
                                    {{isAnswerItemNotFullMark(chosenAnswerItem) ? 'إجابة صحيحة جزئياً' : 'إجابة صحيحة'}}
                                </span>
                                <span v-else-if="reviewState(chosenAnswerItem) === 'incorrect'" class="error--text">
                                    <v-icon color="error">mdi-close-thick</v-icon>
                                    إجابة خاطئة
                                </span>
                                <span v-else-if="reviewState(chosenAnswerItem) === 'pending'" class="muted--text">
                                    <v-icon color="muted">mdi-alert-circle-outline</v-icon>
                                    لم يُصحّح
                                </span>
                                <span v-if="hasMark(chosenAnswerItem.correction_mark)" class="font-weight-medium rtl-dir" style="font-size: 1rem" :class="{'font-weight-bold error--text': isAnswerItemNotFullMark(chosenAnswerItem)}">({{chosenAnswerItem.correction_mark}} من {{chosenAnswerItem.question_mark}})</span>
                                <span v-else-if="chosenAnswerItem.question_mark" class="font-weight-medium" style="font-size: 1rem">({{unitFormat(chosenAnswerItem.question_mark, 'درجة', 'درجتان', 'درجات')}})</span>
                            </div>
                            <div v-else-if="activeQuestion.type !== 'essay'">
                                <span v-if="activeQuestion.type === 'choices'">اختر اﻹجابة الصحيحة:</span>
                                <span v-else-if="activeQuestion.type === 'truefalse'">اختر صواب أم خطأ:</span>
                                <span v-else-if="activeQuestion.type === 'essay'">أجب:</span>
                            </div>
                        </div>
                        <div v-if="activeQuestion.image_url" class="d-flex justify-center">
                            <div class="mb-4 bordered btn-radius overflow-hidden pa-3">
                                <v-img :transition="false" contain :src="activeQuestion.image_url" max-height="300" max-width="600" rounded v-ripple="{class: 'ripple--color'}" @click="openFullImageViewer" class="e-link"></v-img>
                            </div>
                        </div>
                        <div class="question-text strong-text--text mt-4 mb-8" :class="{'essay-question': activeQuestion.type === 'essay','short-question': activeQuestion.text.length < 225, 'long-question': activeQuestion.text.length > 225, 'rtl-dir text-right': activeQuestionDir === 'rtl', 'ltr-dir text-left': activeQuestionDir === 'ltr'}">
                            {{activeQuestion.text}}
                        </div>

                        <div class="essay-answer" v-if="activeQuestion.type === 'essay'">
                            <v-textarea v-model="answers[chosenAnswerIndex].answer_text" outlined :readonly="!isActive" no-resize auto-grow rows="6" :placeholder="isActive ? 'اكتب إجابتك...' : ''" hide-details class="essay-textarea" @input="sendEssayAnswer(answers[chosenAnswerIndex])">

                            </v-textarea>

                            
                            <exam-image-answer-picker v-if="isActive && exam.enable_images_answers && !answers[chosenAnswerIndex].answer_saved_image" :key="'image-picker-' + activeQuestion.id" :upload="(image, onProgress)=>sendImageAnswerToBackend(answers[chosenAnswerIndex], image, onProgress)" :disabled="deletingImageOf === activeQuestion.id" />

                            <div v-if="answers[chosenAnswerIndex].answer_saved_image" class="pa-4 bordered mt-6">
                                <div class="d-flex align-center mb-4">
                                    <h3>إجابة مرفقة</h3>
                                    <v-btn v-if="isActive" color="error" depressed rounded small class="ms-3" :loading="deletingImageOf === activeQuestion.id" @click="deleteImageAnswer(answers[chosenAnswerIndex])">
                                        <v-icon left class="me-1">mdi-close</v-icon>
                                        حذف
                                    </v-btn>
                                </div>
                                <v-img :transition="false" :src="answers[chosenAnswerIndex].answer_saved_image" width="300" class="answer-image-preview"></v-img>
                            </div>
                            <exam-answer-feedback v-if="showDetailedResult && !isActive && chosenAnswerItem.feedback" :feedback="chosenAnswerItem.feedback" />
                        </div>
                        <v-list v-else class="answers pa-0 my-4">
                            <v-row>
                                <v-col v-for="answer in activeQuestion.answers" :key="answer.id" cols="12" :md="answersAreLong ? 12 : 6" class="py-0">
                                    <v-list-item :key="answer.id" color="secondary" class="py-1 px-3 px-md-5 answer mb-2 lighten-5" :class="{'v-list-item--active': chosenAnswer === answer.id || (answer.correct && showDetailedResult), 'secondary--text': chosenAnswer === answer.id, 'error--text': answer.correct === false && showDetailedResult, 'success--text': answer.correct && showDetailedResult, 'ltr-dir text-left': detectDir(answer.text) === 'ltr', 'v-list-item--disabled': activeQuestionLoading}" @click="isActive && !activeQuestionLoading ? chooseAnswer(answer) : ''" v-ripple="phoneOnly && isActive && !activeQuestionLoading">
                                        <v-list-item-icon :style="detectDir(answer.text) === 'ltr' ? 'direction: ltr; margin-left: 0; margin-right: 24px;' : ''">
                                            <v-icon :color="showDetailedResult ? (answer.correct ? 'success' : (chosenAnswer === answer.id ? 'error' : 'muted')) : '' " style="border-radius: 50%" :style="chosenAnswer === answer.id ? 'box-shadow: 0 0 0 2px;' : ''">
                                                {{answer.correct && showDetailedResult ? 'mdi-check-circle' : (answer.correct === false && showDetailedResult ? 'mdi-close-circle' : 'mdi-circle')}}{{(chosenAnswer === answer.id ? '' : '-outline')}}
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title class="strong-text--text">
                                                <div class="d-flex pa-2" v-if="answer.image_url">
                                                    <img :src="answer.image_url" style="max-height: 75px; max-width: 100%"/>
                                                </div>
                                                <div class="answer-text strong-text--text" :class="{'font-weight-bold': activeQuestion.type === 'truefalse'}" v-else>
                                                    <template v-if="activeQuestion.type === 'truefalse' && !showDetailedResult">
                                                        <v-icon v-if="answer.text === 'صواب'" color="success darken-1" class="me-2">mdi-check-bold</v-icon>
                                                        <v-icon v-else-if="answer.text === 'خطأ'" color="error" class="me-2">mdi-close-thick</v-icon>
                                                    </template>
                                                    {{answer.text}}
                                                </div>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                        </v-list>

                        <template v-if="showDetailedResult && (activeQuestion.answer_explain_text || activeQuestion.answer_explain_image || activeQuestion.answer_explain_audio)">
                            <v-divider class="my-8"></v-divider>
                            <v-alert :color="chosenAnswerItem.correct ? 'indigo' : 'amber darken-1'" text outlined class="py-3 px-5">
                                <div>
                                    <h4 class="strong-text--text mb-1">{{ exam.origin === 'student_practice' ? 'توضيح الإجابة · مولّد بالذكاء الاصطناعي' : 'توضيح من المعلم' }}</h4>
                                    <div v-if="activeQuestion.answer_explain_text" class="medium-text strong-text--text" style="font-size: 0.95rem; white-space: pre-line;" v-html="urlify(escapeHtmlText(activeQuestion.answer_explain_text))"></div>
                                </div>
                                <div v-if="activeQuestion.answer_explain_image" style="position: relative;" class="mt-3">
                                    <img :src="activeQuestion.answer_explain_image" style="max-width: 100%; max-height: 420px; border-radius: 5px;" />
                                </div>
                                <div v-if="activeQuestion.answer_explain_audio" class="bordered rounded-lg pa-1">
                                    <audio-player :url="activeQuestion.answer_explain_audio" />
                                </div>
                            </v-alert>
                        </template>

                        <div class="d-flex align-center py-3 mt-6">
                            <v-btn depressed :disabled="activeQuestionIndex <= 1" @click="toPreviousQuestion" class="btn-radius">
                                <v-icon left>mdi-arrow-right</v-icon>
                                <span>السابق</span>
                            </v-btn>
                            <v-spacer />
                            <v-btn v-if="activeQuestionIndex < questions.length || !isActive" :dark="!(activeQuestionIndex >= questions.length)" color="secondary" depressed :disabled="activeQuestionIndex >= questions.length" @click="toNextQuestion" class="btn-radius">
                                <span>السؤال التالي</span>
                                <v-icon right>mdi-arrow-left</v-icon>
                            </v-btn>
                            <v-btn v-else dark color="success" depressed @click="submitSessionDialog = true" class="btn-radius">
                                <v-icon size="20" left>mdi-clipboard-check-outline</v-icon>
                                <span>تسليم اﻹجابات</span>
                            </v-btn>
                        </div>
                    </div>
                    </transition>

                
                </template>
                <div v-else-if="loading">
                    <v-skeleton-loader type="heading" ></v-skeleton-loader>
                    <v-skeleton-loader type="list-item-two-line" ></v-skeleton-loader>
                    <v-skeleton-loader type="list-item-three-line" ></v-skeleton-loader>
                </div>
            </v-card>
        </v-container>


        <v-navigation-drawer v-if="questions && (!showSubmitted || showDetailedResult)" v-model="navigationDrawer" :permanent="pcOnly" :temporary="phoneOnly" app left class="questions-navigation">
            <v-card-title style="font-size: 1.1rem" class="px-5">
                <!-- <v-icon size="22" class="me-2">mdi-menu</v-icon> -->
                قائمة اﻷسئلة
            </v-card-title>
            
            <v-list v-model="active" nav class="pa-0 transparent secondary--text pt-2 pb-8">
                <v-list-item-group v-model="active">
                <template v-for="(question, i) in questions">
                    <!-- <v-divider class="mb-1" v-if="item.divider" :key="'d-' + i" /> -->

                    <v-list-item color="secondary" :key="i + '-' + question.id" :value="question.id" class="px-6" :class="{'opacity-75': active !== question.id && !isSolved(question), 'border-right': active === question.id}" :disabled="active === question.id"> <!-- v-ripple="phoneOnly" -->
                        <v-list-item-icon class="ml-4">
                            <v-icon v-if="!showDetailedResult" :color="isSolved(question) && active !== question.id ? 'primary' : ''">mdi-file-question{{active === question.id || isSolved(question) ? '' : '-outline'}}</v-icon>
                            <v-icon :color="isCorrect(question) ? (isCorrectButNotFull(question) ? 'text' : 'success') : 'error'" v-else>{{isCorrect(question) ? 'mdi-check-circle' : 'mdi-close-circle'}}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title style="font-size: 0.95rem; line-height: 1.4rem">السؤال {{i+1}}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon class="my-auto">
                            <v-icon size="14" :color="isSolved(question) ? 'primary' : 'muted lighten-1'">mdi-radiobox{{isSolved(question) ? '-marked' : '-blank'}}</v-icon>
                        </v-list-item-icon>

                    </v-list-item>
                </template>
                </v-list-item-group>
            </v-list>

            <div v-if="isActive" class="px-4 py-2">
                <v-btn block depressed :color="solvedAnswers.length < questions.length ? 'primary' : 'success'" :outlined="solvedAnswers.length < questions.length" @click="submitSessionDialog = true">
                    <v-icon size="20" left>mdi-clipboard-check-outline</v-icon>
                    <span>تسليم اﻹجابات</span>
                </v-btn>
            </div>
        </v-navigation-drawer>
        <template v-if="questions && (!showSubmitted && !showResult)">
            <v-progress-linear v-if="questions" :value="(activeQuestionIndex / questions.length)*100" color="secondary" background-color="transparent" height="3" absolute top />

            <v-btn v-if="questions && phoneOnly" large fab color="secondary" style="z-index: 5" fixed bottom left @click="navigationDrawer = !navigationDrawer">
                <v-icon>mdi-menu</v-icon>
            </v-btn>

            <v-dialog v-model="showContinueDialog" max-width="300" overlay-color="#000">
                <v-card>
                    <v-card-title class="mb-2">أهلاً مجدداً</v-card-title>
                    <v-card-subtitle>{{ exam.duration ? 'لقد سجلنا إجاباتك السابقة. استكمل الامتحان خلال الوقت المتبقي.' : 'لقد سجلنا إجاباتك السابقة. استكمل تدريبك على مهل، بلا مؤقّت.' }}</v-card-subtitle>
                    <v-card-text class="px-1 pb-2">
                        <v-list class="pa-0 ma-0">
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-icon color="secondary">mdi-radiobox-marked</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-subtitle>اﻷسئلة المجاب عنها</v-list-item-subtitle>
                                    <v-list-item-title class="font-weight-bold">{{continueDialogAttempts}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-icon color="grey">mdi-radiobox-blank</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-subtitle>عدد اﻷسئلة المتبقية</v-list-item-subtitle>
                                    <v-list-item-title class="font-weight-bold">{{questions.length - continueDialogAttempts}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                    <v-card-actions class="pb-3">
                        <v-btn block depressed color="primary" @click="showContinueDialog = false">استكمل اﻵن</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>


            <v-dialog v-model="submitSessionDialog" max-width="450" overlay-color="#000">
                <v-card>
                    <v-card-title class="mb-2 d-flex justify-space-between">
                        <div>
                            <v-icon class="me-2" color="strong-text">mdi-clipboard-check-outline</v-icon>
                            <span>تسليم اﻹجابات</span>
                        </div>
                        <div>
                            <v-btn icon @click="submitSessionDialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-alert v-if="questions.length - solvedAnswers.length" text type="error" dense color="deep-orange" class="medium-text">
                            <div class="strong-text--text">
                                لقد تركت <b>{{questions.length - solvedAnswers.length}} أسئلة</b> بدون إجابة
                            </div>
                        </v-alert>
                        <v-alert text dense color="blue-grey" class="mb-0">
                            <div class="strong-text--text medium-text" style="line-height: 1.8">
                                هل أنت متأكد من تسليم اﻹجابات وإنهاء الامتحان؟ لن تتمكن بعد التسليم من تعديل الإجابات أو العودة للامتحان.
                            </div>
                        </v-alert>
                    </v-card-text>
                    <v-card-actions class="pb-3">
                        <v-btn :loading="submitting" dark large block depressed :color="solvedAnswers.length < questions.length ? 'grey darken-3' : 'success'" @click="submitCurrentSession">
                            <v-icon size="22" left>mdi-clipboard-check-outline</v-icon>
                            <b>تأكيد تسليم اﻹجابات</b>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>


            <!-- full image viewer -->
            <img-viewer :src="activeQuestion ? activeQuestion.image_url : ''" @inited="photoViewerInited" />
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import InfinityWrapper from '@/components/default/infinity-wrapper'
import ImgViewer from '@/components/default/img-viewer'
import ExamResultWait from '@/components/custom/exam-result-wait.vue'
import ExamPersonalReport from '@/components/custom/exam-personal-report.vue'
import ExamAnswerFeedback from '@/components/custom/exam-answer-feedback.vue'
import { nullableMark, normalizeAttemptReview, answerReviewState } from '@/helpers/exam-review'
import AudioPlayer from '@/components/custom/audio-player.vue'
import ExamImageAnswerPicker from '@/components/custom/exam-image-answer-picker.vue'

import debounce from 'lodash.debounce';

import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';

export default {
    name: "Exam",
    components: {ExamPersonalReport, ExamResultWait,
        ExamAnswerFeedback,
        InfinityWrapper,
        AudioPlayer,
        ImgViewer,
        ExamImageAnswerPicker
    },
    props: {
        sessionToken: {},
        reportQuestionId: {},
        fromReport: Boolean,
        course_id: {},
    },
    data(){
        return {
            loading: false,
            submitting: false,
            active: null,
            navigationDrawer: false,

            session: null,
            exam: null,
            questions: null,
            answers: [],

            interval: null,
            remainingSeconds: null,

            continueDialogAttempts: null,
            showContinueDialog: false,

            submitSessionDialog: false,

            showSubmitted: false,
            showDetailedResult: false,
            result: false,
            showResult: false,

            $viewer: null,

            sendingAnswerOfQuestions: [],
            failedSaveQuestions: [],
            deletingImageOf: null,
        }
    },
    computed: {
        ...GlobalComputed,
        isActive(){
            return this.session.active && !this.showSubmitted;
        },
        activeQuestion(){
            return this.questions ? this.questions.find(q=>q.id === this.active) : null;
        },
        activeQuestionLoading(){
            return this.activeQuestion && this.sendingAnswerOfQuestions.includes(this.activeQuestion.id);
        },
        answersAreLong(){
            let long = false;
            if (this.activeQuestion && this.activeQuestion.answers){
                this.activeQuestion.answers.forEach(answer=>{
                    if (answer.image_url || answer.text.length > 40){
                        long = true;
                    }
                });
            }
            return long;
        },

        activeQuestionDir(){
            return this.activeQuestion && this.activeQuestion.text ? this.detectDir(this.activeQuestion.text) : 'rtl';
        },
        chosenAnswerItem(){
            return this.answers.find(item=>item.question_id === this.activeQuestion.id);
        },
        chosenAnswerIndex(){
            return this.answers.findIndex(item=>item.question_id === this.activeQuestion.id);
        },
        
        chosenAnswer(){
            return this.chosenAnswerItem.chosen_answer;
        },
        activeQuestionIndex(){
            return this.questions ? this.questions.findIndex(q=>q.id === this.active) + 1 : null;
        },
        solvedAnswers(){
            return this.answers.filter(answer=>{
                return answer.chosen_answer || answer.answer_text || answer.answer_saved_image;
            });
        },
        timerFormated(){
            return this.formatSeconds(this.remainingSeconds);
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        remainingSeconds(remainingSeconds){
            if (!this.submitting && !this.showSubmitted){
                if (remainingSeconds < 1){
                    this.submitCurrentSession().catch(e=>{
                        this.submitCurrentSession().catch(e2=>{
                            if (!this.showSubmitted){
                                this.showSubmitted = true;
                            }
                        })
                    });
                }
            }
        }
    },
    methods: {
        openReportQuestion(id) {if (this.questions && this.questions.some(q => q.id === id)) {this.active = id; this.showDetailedResult = true}},
        ...GlobalMethods,
        openFullImageViewer(){
            this.$viewer.show();
        },
        photoViewerInited(viewer) {
            this.$viewer = viewer;
        },
        toPreviousQuestion(){
            this.active = this.questions[this.activeQuestionIndex-2].id;
        },
        toNextQuestion(){
            this.active = this.questions[this.activeQuestionIndex].id;
        },
        chooseAnswer(answer){
            const question_id = this.activeQuestion.id;
            let answerIndex = this.answers.findIndex(item=>item.question_id === question_id);
            // let new_answer = this.answers[answerIndex].chosen_answer === answer.id ? null : answer.id; // allow unmark
            let new_answer = answer.id;

            let old_answer = this.answers[answerIndex].chosen_answer;
            if (!old_answer || old_answer !== new_answer || this.failedSaveQuestions.includes(question_id)){
                Object.assign(this.answers[answerIndex], {chosen_answer: new_answer});
    
                // send to backend
                this.setQuestionAnswerSending(question_id, true);
                this.sendAnswersToBackend([this.answers[answerIndex]]).then(()=>{
                    this.setQuestionAnswerSending(question_id, false);
                }).catch(e=>{
                    this.setQuestionAnswerSending(question_id, false);
                });
            }
        },
        setQuestionAnswerSending(question_id, sending){
            if (sending){
                this.sendingAnswerOfQuestions.push(question_id);
            }else{
                this.sendingAnswerOfQuestions = this.sendingAnswerOfQuestions.filter(q_id=>q_id !== question_id);
            }
        },
        detectDir(text){
            const rtlChar = /[\u0590-\u083F]|[\u08A0-\u08FF]|[\uFB1D-\uFDFF]|[\uFE70-\uFEFF]/mg;
            if (text){
                if (rtlChar.test(text.charAt(0))){
                    // is rtl 
                    return 'rtl';
                }else{
                    return 'ltr';
                }
            }
            return 'rtl';
        },
        hasMark(value){ return nullableMark(value) !== null; },
        reviewState: answerReviewState,
        isSolved(question){
            return this.solvedAnswers.some(answer=>answer.question_id === question.id);
        },
        isCorrect(question){
            const state = answerReviewState(this.answers.find(item=>item.question_id === question.id));
            return state === 'full' || state === 'partial';
        },
        isCorrectButNotFull(question){
            const answerItem = this.answers.find(item=>item.question_id === question.id);
            return this.isAnswerItemNotFullMark(answerItem);
        },
        isAnswerItemNotFullMark(answerItem){
            return answerReviewState(answerItem) === 'partial';
        },
        getSessionData(){
            if (!this.loading && this.sessionToken){
                this.loading = true;
                window.axios.get(`/exams/session?session_token=${this.sessionToken}`).then(response=>{
                    this.loading = false;
                    // this.exam_code = '';
                    this.setData(response.data);
                    

                }).catch(error=>{
                    // console.error(error)
                    if (error && error.response && error.response.data){
                        const msg = error.response.data;
                        if (msg === 'SESSION_NOT_FOUND'){
                            this.showMsg('الجلسة غير موجودة', 'error');
                        }else{
                            this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                        }
                    }else{
                        this.showMsg('حدثت مشكلة أثناء جلب بيانات الامتحان', 'error');
                    }
                    this.loading = false;
                })
            }
        },
        setData(data){
            this.session = data.session;
            this.remainingSeconds = data.session.remaining_seconds;
            this.setCounterInterval();
            
            this.exam = data.exam;
            this.showSubmitted = !data.session.active;
            this.result = data.result || null;
            if (!this.result || data.session.active || !data.exam.show_detailed_result) {
                this.showDetailedResult = false;
                this.showResult = false;
            }
            this.questions = [];
            this.answers = [];
            this.active = null;
            if (data.questions && data.questions.length){
                this.active = data.questions[0].id;
                this.questions = data.questions.map(question=>{
                    // if suffled_answers enabled, shuffle it!
                    if (data.exam.shuffled_answers && question.type === 'choices'){
                        question.answers = this.shuffleArray(question.answers);
                    }
                    return question;
                });
                this.answers = data.questions.map((question, i)=>{
                    if (question.type === 'essay'){
                        return {answer_attempt_id: null, question_id: question.id, question_order: i+1, answer_text: null, answer_image: null, answer_saved_image: null, correct: null, question_mark: null, correction_mark: null, feedback: null};
                    }else{
                        return {answer_attempt_id: null, question_id: question.id, question_order: i+1, chosen_answer: null, correct: null, question_mark: null, correction_mark: null, feedback: null};
                    }
                });
                if (data.answer_attempts && data.answer_attempts.length){
                    this.setAnswerAttempts(data.answer_attempts);
                    if (this.isActive){
                        this.active = data.answer_attempts[data.answer_attempts.length-1].question_id;
                        this.openContinueDialog(data.answer_attempts);
                    }
                }

            }
            if (this.fromReport && this.result && !data.session.active) {
                this.showResult = true;
                if (this.reportQuestionId) this.openReportQuestion(Number(this.reportQuestionId));
            }
        },
        setAnswerAttempts(attempts){
            attempts.forEach(attempt=>{
                let answerIndex = this.answers.findIndex(answer=>answer.question_id === attempt.question_id);
                if (answerIndex < 0) return;
                const obj = normalizeAttemptReview(attempt);
                if (attempt.answer_id){
                    obj.chosen_answer = attempt.answer_id;
                }
                if (attempt.answer_text || attempt.answer_text === null){
                    obj.answer_text = attempt.answer_text || '';
                }
                if (attempt.answer_image || attempt.answer_image === null){
                    obj.answer_saved_image = attempt.answer_image;
                    obj.answer_image = null; // reset file binary data
                }
                Object.assign(this.answers[answerIndex], obj);
            })
        },
        sendEssayAnswer: debounce(function (answer){
            const question_id = answer.question_id;
            if (this.isActive){
                // send to backend
                this.setQuestionAnswerSending(question_id, true);
                this.sendAnswersToBackend([answer]).then(()=>{
                    this.setQuestionAnswerSending(question_id, false);
                }).catch(e=>{
                    this.setQuestionAnswerSending(question_id, false);
                });
            }
        }, 1000),
        retryFailedAnswers(){
            const pending = this.answers.filter(answer=>this.failedSaveQuestions.includes(answer.question_id));
            pending.forEach(answer=>this.setQuestionAnswerSending(answer.question_id, true));
            return this.sendAnswersToBackend(pending).catch(()=>{}).finally(()=>{
                pending.forEach(answer=>this.setQuestionAnswerSending(answer.question_id, false));
            });
        },
        sendAnswersToBackend(answers){
            answers = answers.map(answer=>{
                let data = {question_id: answer.question_id}
                if (answer.answer_text || answer.answer_text === ''){
                    data.answer_text = answer.answer_text === '' ? null : answer.answer_text;
                }else{
                    data.chosen_answer = answer.chosen_answer;
                }
                return data;
            });
            return new Promise((resolve, reject)=>{
                window.axios.post('/exams/session/answers', {session_token: this.sessionToken, answers}).then(response=>{
                    const data = response.data;
                    if (data.remaining_seconds){
                        // sync timer with backend
                        const diff = Math.abs(this.remainingSeconds - data.remaining_seconds);
                        // if diff is > 2 seconds
                        if (diff > 2){
                            this.remainingSeconds = data.remaining_seconds;
                        }
                    }
                    this.setAnswerAttempts(data.answer_attempts);
                    const savedIds = answers.map(answer=>answer.question_id);
                    this.failedSaveQuestions = this.failedSaveQuestions.filter(id=>!savedIds.includes(id));
                    resolve(response);
    
                }).catch(error=>{
                    // console.error(error);
                    this.failedSaveQuestions = [...new Set([...this.failedSaveQuestions, ...answers.map(answer=>answer.question_id)])];
                    reject(error);
                })
            })
        },
        // image: Blob to save, or null to remove the saved image. Returns a promise that rejects on failure.
        sendImageAnswerToBackend(answer, image = null, onProgress = null){
            if (!this.isActive) return Promise.reject(new Error('inactive'));
            const question_id = answer.question_id;
            this.setQuestionAnswerSending(question_id, true);

            const data = new FormData();
            data.append('session_token', this.sessionToken);
            data.append('question_id', question_id);
            data.append('answer_text', answer.answer_text || '');
            if (image){
                const ext = (image.type && image.type.split('/')[1] || 'jpg').replace('jpeg', 'jpg').replace(/[^a-z0-9]/gi, '');
                data.append('answer_image', image, `answer-${question_id}-${Date.now()}.${ext}`);
            }

            return window.axios.post('/exams/session/answers/image', data, {
                onUploadProgress: e=>{
                    if (onProgress && e.total) onProgress(Math.min(99, Math.round(e.loaded * 100 / e.total)));
                },
            }).then(response=>{
                const responseData = response.data;
                if (responseData.remaining_seconds){
                    // sync timer with backend
                    const diff = Math.abs(this.remainingSeconds - responseData.remaining_seconds);
                    // if diff is > 2 seconds
                    if (diff > 2){
                        this.remainingSeconds = responseData.remaining_seconds;
                    }
                }
                this.setAnswerAttempts(responseData.answer_attempts);
                return response;
            }).finally(()=>{
                this.setQuestionAnswerSending(question_id, false);
            });
        },
        deleteImageAnswer(answer){
            if (this.deletingImageOf) return;
            this.deletingImageOf = answer.question_id;
            this.sendImageAnswerToBackend(answer).catch(()=>{
                this.showMsg('تعذر حذف الصورة، حاول مرة أخرى');
            }).finally(()=>{
                this.deletingImageOf = null;
            });
        },
        submitCurrentSession(){
            if (!this.submitting){
                this.submitting = true;
                let answers = this.answers.map(answer=>{
                    let data = {question_id: answer.question_id}
                    if (answer.answer_text || answer.answer_text === ''){
                        data.answer_text = answer.answer_text === '' ? null : answer.answer_text;
                    }else{
                        data.chosen_answer = answer.chosen_answer;
                    }
                    return data;
                });
                
                return window.axios.post('/exams/session/submit', {session_token: this.sessionToken, answers}).then(response=>{
                    const data = response.data;
                    if (data.result){
                        this.result = data.result;
                    }
                    if (data.answer_attempts){
                        this.setAnswerAttempts(data.answer_attempts);
                    }
                    if (data.questions){
                        this.active = data.questions[0].id;
                        this.questions = data.questions;
                    }
                    this.submitSessionDialog = false;
                    window.setTimeout(()=>{
                        this.showSubmitted = true;
                        this.submitting = false;
                    }, 500);
                    this.showMsg('تم تسليم اﻹجابات بنجاح', 'success');
                }).catch(error=>{
                    // handle error!
                    // console.error(error);
                    this.submitting = false;
                    this.showMsg('حدثت مشكلة أثناء تسليم الإجابات', 'error');
                })
            }
        },
        openContinueDialog(attempts){
            this.continueDialogAttempts = attempts.length;
            this.showContinueDialog = true;
        },
        confirmReloadListener(){
            // confirm reload..
            window.onbeforeunload = function(event){
                event.preventDefault();
                return false;
                // return event.returnValue = "هل أنت متأكد من مغادرة الامتحان؟ لن يتوقف عداد الوقت وستتمكن من استكمال الامتحان لحين انتهاء الوقت المحدد لك";
            }
        },
        formatSeconds(seconds){
            let remaining = seconds * 1000; // in milliseconds
            if (remaining){
                // Time calculations for days, hours, minutes and seconds
                let hours = Math.floor(remaining / (1000 * 60 * 60));
                let minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((remaining % (1000 * 60)) / 1000);

                let hoursText = hours < 10 ? "0" + hours : hours;
                let minutesText = minutes < 10 ? "0" + minutes : minutes;
                let secondsText = seconds < 10 ? "0" + seconds : seconds;

                return hours ? `${hoursText}:${minutesText}:${secondsText}` : `${minutesText}:${secondsText}`;
            }else{
                return '00:00';
            }
        },
        setCounterInterval(){
            if (!this.interval){
                this.interval = window.setInterval(()=>{
                    if (this.remainingSeconds && this.remainingSeconds > 0){
                        this.remainingSeconds -= 1;
                    }
                }, 1000);
            }
        },
        shuffleArray(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
            return array;
        },
        urlify(text){
            const options = { defaultProtocol: 'https' , target: '_system'};
            return linkifyHtml(text, options);
        },
        escapeHtmlText(text){
            // to prevent XSS attacks
            return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        },
    },
    beforeDestroy(){
        window.onbeforeunload = null;
        if (this.interval){
            window.clearInterval(this.interval);
        }
    },
    created(){
        if (!this.sessionToken){
            this.$router.push({name: 'exams', query: {course_id: this.course_id}});
        }
    },
    mounted(){
        this.getSessionData();
        this.confirmReloadListener();
    }
};
</script>

<style lang="scss" scoped>
    .question-card{
        &, *{
            user-select: none!important;
        }
        .btn-radius{
            border-radius: 7px;
        }
        .question-chips{
            position: absolute;
            top: 0;
            right: 0;
            transform: translateY(-50%);
            .question-chip{
                border-radius: 8px;
            }
        }
        .answers{
            .v-list-item.answer{
                border-radius: 10px!important;
                overflow: hidden;
                border: 1px solid;
                &:not(.v-list-item--active){
                    border-color: rgba(0,0,0, .1);
                }
            }
            .answer-text{
                white-space: pre-line;
            }
        }
        .question-header{
            font-size: 1.2rem;
            font-weight: bold;
        }
        .question-text{
            white-space: pre-line;
            &.short-question{
                font-size: 1rem;
                line-height: 1.75;
                @media(min-width: 765px){
                    background: #f1f1f1;
                    // border: 1px solid #eee;
                    border-radius: 8px;
                    padding: 0.75rem 1.25rem;
                }
                @media(max-width: 765px){
                    font-size: 0.95rem;
                }

                &.essay-question{
                    font-weight: bold;
                }
            }
            &.long-question{
                font-size: 0.92rem;

                @media(max-width: 765px){
                    font-size: 0.88rem;
                }
            }
        }
    }
</style>

<style lang="scss">
    .questions-navigation .v-navigation-drawer__content{
        &::-webkit-scrollbar{
            background: #fff!important;
            height:11px;
            width:8px;
        }
    }
    .questions-navigation .v-navigation-drawer__content{
        &::-webkit-scrollbar-track{
            // border-radius: 5px;
        }
        &::-webkit-scrollbar-thumb{
            background: rgba(0, 0, 0, 0.15);
            border-radius: 6px!important;
        }
        &::-webkit-scrollbar-thumb:hover{
            background: rgba(0, 0, 0, 0.25);
        }
        /* &::-webkit-scrollbar-thumb:active{
            background: rgba(0,0,0, .25);
        } */
    }
    .opacity-75{
        opacity: 0.75;
    }
    .questions-navigation{
        .v-list-item{
            border-radius: 0!important;
            &.border-right{
                border-right: 3px solid;
            }
            &.v-list-item--active{
                &::before{
                    opacity: 0!important;
                }
            }
        }
    }

    .essay-textarea{
        textarea{
            font-size: 15px;

            @media(max-width: 960px){
                font-size: 14px;
            }
        }
        fieldset{
            border-width: 1px!important;
        }
    }
    .answer-image-preview{
        border: 2px solid #888;
    }

</style>
<style>
@media (max-width: 959px) {
    .practice-exam .v-btn { min-height: 44px; }
    .practice-exam .v-btn--icon { min-width: 44px; }
    .practice-exam .question-text.short-question,
    .practice-exam .question-text.long-question { font-size: 16px !important; line-height: 1.9; }
    .practice-exam .question-text,
    .practice-exam .answer-text { overflow-wrap: anywhere; }
    .practice-exam .v-list-item__title { white-space: normal; overflow-wrap: anywhere; line-height: 1.7; }
}
</style>
